import React from 'react'
import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material'
import { TouchableOpacity } from 'react-native'
import { Close } from '@mui/icons-material'
import { color, Text } from '@trivie/ui-mobile'
import { observer } from 'mobx-react-lite'

export interface SortCommentsProps {
  open: boolean
  onClose: any
  setLoading: any
  onSortChange: any
}

export const SortComment = observer((props: SortCommentsProps) => {
  const { open, onClose, onSortChange } = props

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog style={{ overflow: 'hidden' }} aria-labelledby="asdasda-dialog-title" open={open}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 24,
          paddingRight: 24,
          maxWidth: 520,
        }}
      >
        <Text variant="labelEmphasized" tx="Discuss.sortBy" />
        <IconButton
          data-qat="close_btn"
          style={{ left: 12 }}
          onClick={(e) => {
            e.stopPropagation()
            handleClose()
          }}
        >
          <Close htmlColor={color.black} style={{ fontSize: 22 }} />
        </IconButton>
      </div>

      <DialogContent style={DIALOG_CONTAINER}>
        <div style={CONTAINER}>
          <TouchableOpacity
            // @ts-ignore
            dataSet={{ qat: `sort_by_top_btn` }}
            accessibilityRole="button"
            accessibilityLabel="Sort by top comments"
            onPress={() => onSortChange('top')}
          >
            <div style={{ ...ITEM_CONTAINER, marginTop: 0 }}>
              <div style={ICON}>
                <svg
                  viewBox="0 0 40 40"
                  width={60}
                  height={60}
                  fill={color.palette.blue}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6.4 9.2h.2c.77 0 1.4.63 1.4 1.4v7c0 .77-.63 1.4-1.4 1.4h-.2c-.77 0-1.4-.63-1.4-1.4v-7c0-.77.63-1.4 1.4-1.4zM12 5c.77 0 1.4.63 1.4 1.4v11.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4V6.4c0-.77.63-1.4 1.4-1.4zm5.6 8c.77 0 1.4.63 1.4 1.4v3.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4v-3.2c0-.77.63-1.4 1.4-1.4z" />
                </svg>
              </div>
              <div style={TITLE}>
                <div style={TOP_TITLE}>
                  <Text tx="Discuss.top" style={{ fontSize: 18 }} />
                </div>
                <div style={SUB_TITLE}>
                  <Text tx="Discuss.mostLikes" style={{ color: color.darkGrey, opacity: 0.8 }} />
                </div>

                <hr style={{ opacity: 0.3, marginRight: 40 }} />
              </div>
            </div>
          </TouchableOpacity>
          <TouchableOpacity
            // @ts-ignore
            dataSet={{ qat: `sort_by_discussions_btn` }}
            accessibilityRole="button"
            accessibilityLabel="Sort by discussions"
            onPress={() => onSortChange('discussions')}
          >
            <div style={ITEM_CONTAINER}>
              <div style={ICON}>
                <svg
                  viewBox="0 0 40 40"
                  width={60}
                  height={60}
                  fill={color.palette.blue}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M20 6h-1v8c0 .55-.45 1-1 1H6v1c0 1.1.9 2 2 2h10l4 4V8c0-1.1-.9-2-2-2zm-3 5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2z" />
                </svg>
              </div>
              <div style={TITLE}>
                <div style={TOP_TITLE}>
                  <Text tx="Discuss.discussions" style={{ fontSize: 18 }} />
                </div>
                <div style={SUB_TITLE}>
                  <Text tx="Discuss.mostReplies" style={{ color: color.darkGrey, opacity: 0.8 }} />
                </div>

                <hr style={{ opacity: 0.3, marginRight: 40 }} />
              </div>
            </div>
          </TouchableOpacity>
          <TouchableOpacity
            // @ts-ignore
            dataSet={{ qat: `sort_by_new_btn` }}
            accessibilityRole="button"
            accessibilityLabel="Sort by comment date"
            onPress={() => onSortChange('new')}
          >
            <div role="article" style={ITEM_CONTAINER}>
              <div style={ICON}>
                <svg
                  viewBox="0 0 40 40"
                  width={60}
                  height={60}
                  fill={color.palette.blue}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
              </div>
              <div style={TITLE}>
                <div style={TOP_TITLE}>
                  <Text tx="Discuss.new" style={{ fontSize: 18 }} />
                </div>
                <div style={SUB_TITLE}>
                  <Text tx="Discuss.sortNew" style={{ color: color.darkGrey, opacity: 0.8 }} />
                </div>
              </div>
            </div>
          </TouchableOpacity>
        </div>
      </DialogContent>
      <DialogActions style={DIALOG_ACTIONS_STYLE}>
        <MuiButton
          data-qat="footer_close_btn"
          variant="contained"
          // disableElevation
          onClick={(e) => {
            e.stopPropagation()
            handleClose()
          }}
          style={{ width: '100%', background: color.blue }}
        >
          <Text
            variant="body1Emphasized"
            tx="Common.close"
            style={{ color: color.white, opacity: 1 }}
          />
        </MuiButton>
      </DialogActions>
    </Dialog>
  )
})

const DIALOG_CONTAINER: React.CSSProperties = {
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 30,
}
const DIALOG_ACTIONS_STYLE: React.CSSProperties = {
  flexDirection: 'column',
  padding: 20,
}
const CONTAINER: React.CSSProperties = {}
const ITEM_CONTAINER: React.CSSProperties = {
  display: 'flex',
  marginTop: 15,
}

const ICON: React.CSSProperties = {
  alignSelf: 'center',
}

const TITLE: React.CSSProperties = {
  width: '100%',
}

const TOP_TITLE: React.CSSProperties = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1.3rem',
}

const SUB_TITLE: React.CSSProperties = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '0.9rem',
  opacity: 0.8,
  color: 'rgba(0, 0, 0, 0.5)',
}
